import React from 'react';

interface TextFieldProps {
    id: string;
    type: string;
    value: string;
    onChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
    placeholder?: string;
    disabled?: boolean;
    maxLength?: number; // New prop for maximum length
    onClick?: () => void;
}

const TextField: React.FC<TextFieldProps> = ({
    id,
    type,
    value,
    onChange,
    placeholder,
    disabled,
    maxLength,
    onClick,
}) => (
    <input
        type={type}
        id={id}
        value={value}
        onChange={onChange}
        onClick={onClick}
        placeholder={placeholder}
        maxLength={maxLength} // Apply maxLength here
        className="h-10 w-full rounded border border-slate-200 px-4 text-sm text-slate-500 dark:border-slate-600 
        dark:bg-slate-800 dark:text-slate-300 outline-none transition-all focus:border-primary dark:focus:border-secondary"
        disabled={disabled}
    />
);

export default TextField;
